import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { userRoleSelector } from '@core/store/selectors/user-role.selectors';
import { ConsentLinksAdapter } from '../adapters/consent-urls.adapter';
import { ConsentUrlsAdapted } from '../models/consent-urls-adapted.model';
import { consentUrlsFeature } from '@core/store/reducers/consent-urls.reducer';
import { ConsentUrls } from '../models/consent-urls.model';
import { ConsentUrlAdaptingParams } from '../models/consent-urls-adapting.params';
import { USER_ROLE } from '@core/store/reducers/session-info.reducer';

@Injectable({
  providedIn: 'root',
})
export class ConsentUrlsService {
  private store = inject(Store);
  private router = inject(Router);
  private consentLinksAdapter = inject(ConsentLinksAdapter);

  public identType$: BehaviorSubject<string> = new BehaviorSubject<
    string | undefined
  >(undefined);

  private userRole$: Observable<USER_ROLE> = this.store.pipe(
    select(userRoleSelector),
  );

  private storedConsents$: Observable<ConsentUrls> = this.store.select(
    consentUrlsFeature.selectConsents,
  );

  //TODO: Refactor and unify this detection of secondPlatform in the app
  public isSecondPlatformPage =
    this.router.url.split('?')[0] === '/profile' ||
    this.router.url === '/privacy-policy-cms';

  /**
   * Exrtact consent links based on user role, identification type or isSecondPlaform condition
   */
  public consents$: Observable<ConsentUrlsAdapted> = combineLatest([
    this.storedConsents$,
    this.userRole$,
    this.identType$,
  ]).pipe(
    map(([consents, userRole, identType]) => {
      const consentUrlAdaptingParams: ConsentUrlAdaptingParams = {
        consents,
        userRole,
        identType,
      };

      return this.consentLinksAdapter.adapt(
        consentUrlAdaptingParams,
        this.isSecondPlatformPage,
      );
    }),
  );
}
